t = require('views/internal/teacup-with-helpers')('org_member_activity')

memberOfBoardsMessage = (
  hasString = 'name-is-member-of-boards'
  hasNoneString = 'name-is-member-of-no-boards'
  variables = {
    name: t.mustacheVar('fullName')
  }
) ->
  t.p '.quiet', ->
    t.mustacheBlock 'hasBoards', ->
      t.format hasString, variables
    t.mustacheBlockInverted 'hasBoards', ->
      t.format hasNoneString, variables

module.exports = ->
  t.mustacheBlock 'teamMembersLayoutExperimentEnabled', ->
    t.mustacheBlock 'isPremium', ->
      t.mustacheBlock 'lastActive', ->
        memberOfBoardsMessage(
          'name-is-member-of-boards-and-has-activity',
          'name-is-member-of-no-boards-but-has-activity',
          {
            name: t.mustacheVar('fullName')
            fullName: t.mustacheVar('fullName'),
            lastActive: t.mustacheVar('lastActive')
          }
        )

      t.mustacheBlockInverted 'lastActive', ->
        memberOfBoardsMessage()

    t.mustacheBlockInverted 'isPremium', ->
      memberOfBoardsMessage()

    t.ul '.pop-over-list', ->
      t.mustacheBlock 'boards', ->
        t.li ->
          t.a { href: t.mustacheVar('url') }, ->
            t.text t.mustacheVar('name')
            t.text ' '
            t.span '.quiet', ->
              t.format 'membertype', { memberType: t.mustacheVar('memberType') }

    t.mustacheBlock 'orgCardsUrl', ->
      t.hr()

      t.ul '.pop-over-list', ->
        t.li ->
          t.a '.js-view-member-org-cards', {
            href: t.mustacheVar('orgCardsUrl')
          }, ->
            t.format 'view-members-org-cards'


  t.mustacheBlockInverted 'teamMembersLayoutExperimentEnabled', ->
    t.ul '.pop-over-list', ->
      t.li ->
        t.mustacheBlock 'hasBoards', ->
          t.a '.js-view-org-boards-for-member', { href: '#' }, ->
            t.format 'on-boardcount', {
              boardCount: t.mustacheVar('boardCount')
            }
        t.mustacheBlockInverted 'hasBoards', ->
          t.a '.disabled', { href: '#' }, ->
            t.format 'on-boardcount', {
              boardCount: t.mustacheVar('boardCount')
            }
      t.mustacheBlock 'orgCardsUrl', ->
        t.li ->
          t.a '.js-view-member-org-cards', {
            href: t.mustacheVar('orgCardsUrl')
          }, ->
            t.format 'view-members-org-cards'

    t.mustacheBlock 'lastActive', ->
      t.hr()

      t.p '.quiet.u-bottom', ->
        t.format 'fullname-was-last-active-in-this-organization', {
          fullName: t.mustacheVar('fullName'),
          lastActive: t.mustacheVar('lastActive')
        }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_member_activity.coffee